window.toggleClass = (element, className, add) => {
    if (add) {
        element.classList.add(className);
    } else {
        element.classList.remove(className);
    }
};

window.addEventListener = (element, event, handler) => {
    element.addEventListener(event, handler);
};

window.dispatchCustomEvent = (eventName) => {
    document.dispatchEvent(eventName);
};

window.getSpanElements = (hamburger) => hamburger.querySelectorAll("span[data-span]");

window.getElement = (id) => document.getElementById(id);

window.getElementsByClassName = (name) => document.getElementsByClassName(name);

window.openSlider = (slider) => {
    toggleClass(slider, "-translate-x-full", false);
    toggleClass(slider, "translate-x-0", true);
};

window.openBottomSlider = (slider) => {
    toggleClass(slider, "translate-y-full", false);
    toggleClass(slider, "translate-y-0", true);
};

window.closeSlider = (slider) => {
    toggleClass(slider, "translate-x-0", false);
    toggleClass(slider, "-translate-x-full", true);
};

window.closeBottomSlider = (slider) => {
    toggleClass(slider, "translate-y-full", true);
    toggleClass(slider, "translate-y-0", false);
};

window.triggerToastMessage = (message, state, duration) => {
    console.log('dispatching event');
    const event = new CustomEvent('initiate-toast-event', {
        detail: {
            message: message,
            state: state,
            duration: duration || 3000
        }
    });
    dispatchCustomEvent(event);
};

window.toogleButtonLoader = (button, loader) => {
    if (loader.classList.contains('hidden')) {
        toggleClass(loader, 'hidden', false);
        toggleClass(loader, 'flex', true);
        button.disabled = true;
    } else {
        toggleClass(loader, 'hidden', true);
        toggleClass(loader, 'flex', false);
        button.disabled = false;
    }
};

window.closePopup = (id) => {
    const element = getElement(id);
    toggleClass(element, 'hidden', true);
    toggleClass(element, 'flex', false);
};

window.openPopup = (id) => {
    const element = getElement(id);
    toggleClass(element, 'hidden', false);
    toggleClass(element, 'flex', true);
};